<footer class="jfooter mt-16 bg-[#f4f7fb] border-t-4 border-journey-yellow text-[13.5px] text-slate-600">
  <div class="max-w-screen-xl mx-auto px-4 sm:px-8 pt-10 pb-6">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-x-6 gap-y-8">
      <div *ngFor="let col of columns">
        <h3 class="text-journey-title font-bold text-[15px]">{{ col.title }}</h3>
        <ul class="mt-3 flex flex-col gap-2">
          <li *ngFor="let link of col.links">
            <a *ngIf="link.route; else external" class="hover:text-journey-title hover:underline underline-offset-2" [routerLink]="link.route">{{ link.label }}</a>
            <ng-template #external><a class="hover:text-journey-title hover:underline underline-offset-2" [href]="link.href" target="_blank" rel="noopener">{{ link.label }}</a></ng-template>
          </li>
        </ul>
      </div>
      <div>
        <h3 class="text-journey-title font-bold text-[15px]">Contáctanos</h3>
        <ul class="mt-3 flex flex-col gap-2">
          <li><a class="font-semibold hover:text-journey-title hover:underline underline-offset-2" href="https://wa.me/573169197373" target="_blank" rel="noopener">WhatsApp 316 919 7373</a></li>
          <li><a class="hover:text-journey-title hover:underline underline-offset-2" href="tel:+573103158650">Teléfono 310 315 8650</a></li>
          <li><a class="hover:text-journey-title hover:underline underline-offset-2 break-all" href="mailto:info@rayo.com.co">info&#64;rayo.com.co</a></li>
        </ul>
      </div>
    </div>

    <p class="jfooter-countries mt-9 text-center">
      <span class="font-bold text-journey-title">Países:</span>&ngsp;
      <ng-container *ngFor="let country of countries; let last = last">
        <a class="hover:text-journey-title hover:underline underline-offset-2" [href]="country.href" target="_blank" rel="noopener">{{ country.label }}</a><span *ngIf="!last" aria-hidden="true"> · </span>
      </ng-container>
    </p>

    <hr class="my-6 border-slate-200">

    <div class="flex flex-col items-center gap-3 text-center">
      <p class="jfooter-entity font-bold text-journey-title">INVERSIONES ARDEL S.A.S. · NIT 902019836-6</p>
      <p class="text-xs">Copyright &copy; {{ year }} Inversiones Ardel S.A.S. Todos los derechos reservados.</p>
      <ul class="flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-xs">
        <li *ngFor="let link of legalLinks">
          <a *ngIf="link.route; else externalLegal" class="underline underline-offset-2 hover:text-journey-title" [routerLink]="link.route">{{ link.label }}</a>
          <ng-template #externalLegal><a class="underline underline-offset-2 hover:text-journey-title" [href]="link.href" target="_blank" rel="noopener">{{ link.label }}</a></ng-template>
        </li>
      </ul>
      <div class="flex gap-5 mt-1">
        <a class="inline-flex items-center gap-1.5 hover:text-journey-title" href="https://www.facebook.com/RayoBogota/" target="_blank" rel="noopener">
          <svg class="size-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.5V4.4c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.4H8v3h2.6V21h2.9z"></path></svg>
          Facebook
        </a>
        <a class="inline-flex items-center gap-1.5 hover:text-journey-title" href="https://www.instagram.com/rayo_col/" target="_blank" rel="noopener">
          <svg class="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r="1" fill="currentColor"></circle></svg>
          Instagram
        </a>
      </div>
    </div>
  </div>
</footer>
